

export class ProviderAlias
{
    constructor
    (
        public id: number,
        public alias: string
    )
    {

    }
}